import * as PasswordConstants from '../../password/constants';

const initialState = {
  isLoading: false
};

export function newPassword(state = initialState, action) {
  switch (action.type) {
    case PasswordConstants.PASSWORD_NEW_SUBMIT_STARTED:
      return Object.assign({}, state, {isLoading: true});
    case PasswordConstants.PASSWORD_NEW_SUBMIT_COMPLETED:
      return Object.assign({}, state, {isLoading: false});
    default:
      return state;
  }
}
